<template>
    <Login></Login>
</template>

<script>
    import Login from '../components/login/Login';
    export default {
        name: "LoginView",
        components: {
            //ES2015+, placing a variable name like ComponentA
            // inside an object is shorthand for ComponentA: ComponentA
            Login
        }
    }
</script>

<style scoped>

</style>
